import { useEffect, useState } from 'react';
import type { Session } from '@supabase/supabase-js';
import { supabase } from './supabase';

// undefined while loading, null when signed out.
export function useSession (): Session | null | undefined {
    const [session, setSession] = useState<Session | null | undefined>(undefined);
    useEffect(() => {
        let active = true;
        supabase.auth.getSession().then(({ data }) => {
            if (active) setSession(data.session);
        });
        const { data: listener } = supabase.auth.onAuthStateChange((event, next) => {
            if (active) setSession(next);
        });
        return () => {
            active = false;
            listener.subscription.unsubscribe();
        };
    }, []);
    return session;
}
